/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'rating-smiley-3': {
    width: 44,
    height: 44,
    viewBox: '0 0 44 44',
    data: `<defs><clipPath id="svgicon_rating-smiley-3_a"><path pid="0" d="M0 0h44v44H0z"/></clipPath></defs><g clip-path="url(#svgicon_rating-smiley-3_a)"><g transform="translate(-490.06 -1438.851)" _fill="none" _stroke="currentColor" stroke-miterlimit="10" stroke-width="1.5"><circle pid="1" cx="21.25" cy="21.25" r="21.25" transform="translate(490.81 1439.601)"/><path pid="2" d="M524.843 1460.212a12.785 12.785 0 01-25.57 0"/><circle pid="3" cx="3.196" cy="3.196" r="3.196" transform="translate(504.544 1452.54)"/><circle pid="4" cx="3.196" cy="3.196" r="3.196" transform="translate(513.494 1452.54)"/><path pid="5" d="M510.937 1455.097h2.557M519.247 1455.097h12.785M491.12 1455.097h14.064"/></g></g>`
  }
})
/* tslint:enable */
